/// <reference path="../types/react-google-recaptcha.d.ts" />
import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { Modal, Text } from '@innolab-trader/ui'
import { useTranslations } from '@innolab-trader/translations'
import { useTheme } from '../theme/ThemeProvider'

export interface RecaptchaModalProps {
  isOpen: boolean
  onClose: () => void
  onVerify: (token: string) => void
  siteKey: string
  title?: string
  message?: string
  onError?: (error: Error) => void
}

export const RecaptchaModal: React.FC<RecaptchaModalProps> = ({
  isOpen,
  onClose,
  onVerify,
  siteKey,
  title,
  message,
  onError
}) => {
  const { isDark } = useTheme()
  const T = useTranslations()

  const handleChange = (token: string | null) => {
    if (token) {
      onVerify(token)
    } else if (onError) {
      onError(new Error('Recaptcha verification failed'))
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? T.modals.recaptcha.title}
      size="sm"
    >
      <div className="px-6 py-5">
        {message && (
          <div className="mb-2">
            <Text>{message}</Text>
          </div>
        )}
        <div className="flex justify-center">
          <ReCAPTCHA
            theme={isDark ? 'dark' : 'light'}
            sitekey={siteKey}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="px-6 py-4 border-t border-border flex justify-end" />
    </Modal>
  )
}
